import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Lock } from "lucide-react";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, ready, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (ready && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-alt px-6 py-16">
      <div className="w-full max-w-md bg-white border border-surface-line rounded-sm shadow-sm p-8">
        <Link to="/" className="flex items-center gap-3">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-sm bg-brand text-white font-display font-black">
            W
          </span>
          <div className="font-display font-bold text-ink">Wellpec</div>
        </Link>
        <div className="mt-8 flex items-center gap-2 text-bronze">
          <Lock className="h-4 w-4" />
          <span className="text-xs font-bold uppercase tracking-[0.22em]">
            Acesso interno
          </span>
        </div>
        <h1 className="mt-3 font-display text-2xl font-bold text-ink">
          Entrar no painel
        </h1>
        <p className="mt-2 text-sm text-ink-muted">
          Área restrita para gestão de leads comerciais da Wellpec.
        </p>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-ink-muted">
              E-mail
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="mt-1 w-full rounded-sm border border-surface-line bg-white px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand-mid focus:border-brand-mid"
              placeholder="admin@wellpec.com.br"
            />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-ink-muted">
              Senha
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="mt-1 w-full rounded-sm border border-surface-line bg-white px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand-mid focus:border-brand-mid"
              placeholder="••••••••"
            />
          </div>
          {err && (
            <p data-testid="login-error" className="text-sm text-destructive">
              {err}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full inline-flex items-center justify-center gap-2 bg-brand text-white font-semibold px-6 py-3 rounded-sm hover:bg-brand-mid transition-colors disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
            Entrar
          </button>
        </form>

        <Link
          to="/"
          className="mt-6 inline-block text-xs text-ink-muted hover:text-brand"
        >
          ← Voltar ao site
        </Link>
      </div>
    </div>
  );
}
